(function() {
  document.addEventListener("DOMContentLoaded", function() {
    var searchIcon = document.getElementById("search-icon");
    var searchIconMobile = document.getElementById("search-icon-mobile");
    var searchContainer = document.getElementById("search-box-container");
    var searchBackdrop = document.getElementById("search-blur-backdrop");
    var predictiveSearchResults = document.querySelector('#predictive-search');
    var cancelButton = document.getElementById("search-cancel-button");

    if(searchIcon) {
    searchIcon.addEventListener("click", function() {
        searchContainer.classList.add("show-search");
        searchBackdrop.classList.add("show-search");
    });

    searchIconMobile.addEventListener("click", function() {
        searchContainer.classList.add("show-search");
        searchBackdrop.classList.add("show-search");
    });

    searchBackdrop.addEventListener("click", function() {
        searchContainer.classList.remove("show-search");
        searchBackdrop.classList.remove("show-search");
        predictiveSearchResults.classList.remove("open");
    });

    cancelButton.addEventListener("click", function() {
        searchContainer.classList.remove("show-search");
        searchBackdrop.classList.remove("show-search");
        predictiveSearchResults.classList.remove("open");
    });
  }
});

class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.searchContainer = document.getElementById('search-box-container');

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&resources[limit]=8&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                const pi = document.querySelector(".predictive-search-product-list");
                if(pi) {
                    pi.style.listStyle = 'none';
                    pi.style.padding = '0';
                    pi.style.display = 'flex';
                    pi.style.flexDirection = 'column';
                    pi.style.alignItems = 'center';
                    pi.style.width = '200px';
                    pi.style.marginBottom = '0';
                }
                const pi1 = document.querySelector(".predictive-search-product-list-1");
                if(pi1) {
                    pi1.style.listStyle = 'none';
                    pi1.style.padding = '0';
                    pi1.style.display = 'flex';
                    pi1.style.flexDirection = 'column';
                    pi1.style.alignItems = 'center';
                    pi1.style.width = '200px';
                    pi1.style.marginBottom = '0';
                }
                const pi2 = document.querySelector(".predictive-search-product-list-2");
                if(pi2) {
                    pi2.style.listStyle = 'none';
                    pi2.style.padding = '0';
                    pi2.style.display = 'flex';
                    pi2.style.flexDirection = 'column';
                    pi2.style.alignItems = 'center';
                    pi2.style.width = '200px';
                    pi2.style.marginBottom = '0';
                }
                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.predictiveSearchResults.classList.add('open');
        this.searchContainer.classList.add('has-results');
    }

    close() {
        this.predictiveSearchResults.classList.remove('open');
        this.searchContainer.classList.remove('has-results');
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
})();
